export default ($axios) => ({
    $axios,

    async statistic() {
        return await $axios.get('/statistic/requests')
    },
})
